
const messages = {
   en: {
      base: {
         home: 'Home',
         about: 'About',
         welcome: "Welcome",
         edit: 'Edit'
      }
   },
   es: {
      base: {
         home: 'Principal',
         about: 'Acerca de',
         welcome: "Bienvenido",
         edit: 'Editar'
      }
   },
   pt: {
      base: {
         home: 'Principal',
         about: 'Acerca de',
         welcome: "Welcome",
         edit: 'Editar'
      }
   }
}

export default messages
    